export default __webpack_public_path__ + "static/media/oil-industry-page.c98c507f.jpg";